import ResponiveImage from '@commons/responsive-image/ResponsiveImage'
import styles from '../shopTheLook/ShopTheLook.module.scss'
import stylesPlaceholders from './Placeholders.module.scss'
import { PlaceholderItem } from './types'

type PlaceholdersProps = {
    items: PlaceholderItem[]
}

export default function Placeholders({ items }: PlaceholdersProps) {
    const renderProductComponents = product => {
        const { title, visual, items } = product

        const renderImage = () => {
            if (!visual.desktop && !visual.mobile) {
                return null
            }

            return (
                <div className={stylesPlaceholders['image__placeholder']}>
                    <ResponiveImage {...visual} />
                </div>
            )
        }

        const renderProductName = () => {
            if (!title) {
                return null
            }

            return <h3 className={'t-sm-500'}>{title}</h3>
        }

        const renderProductListDetails = items => {
            return (
                <>
                    {items.map(item => (
                        <span className={'t-xs-500'}>{item}</span>
                    ))}
                </>
            )
        }

        const renderProductPlaceholder = () => {
            return (
                <div className={stylesPlaceholders['items__showcase']}>
                    {renderProductName()}
                    {renderProductListDetails(items)}
                </div>
            )
        }

        return (
            <div className={styles['shop-the-look']}>
                {renderImage()}
                {renderProductPlaceholder()}
            </div>
        )
    }

    return (
        <div className={stylesPlaceholders['items__list']}>
            {items.map(item => (
                <>{renderProductComponents(item)}</>
            ))}
        </div>
    )
}
